export default "__VITE_ASSET__Cz3KRgt1__"